export { default } from './MentionMe';



// WEBPACK FOOTER //
// ./src/client/js/view/components/MentionMe/index.js